<template>
  <div>
    <iframe
      class="iframe_dashboard"
      title="Report Section"
      :src="iFrame"
      frameborder="0"
      allowFullScreen="true"
    >
    </iframe>
  </div>
</template>
  
<script>
import axios from 'axios';

  export default {
    data(){
      return{
        iFrame: null,
        arrayIframesByDist:[
          {
            id: 11226,
            name: "Comtexaco",
            src: "https://app.powerbi.com/view?r=eyJrIjoiMDQxMDYwMjEtY2JlZS00NzNhLTkyY2QtN2JiODQxNTRiZDBmIiwidCI6IjY1NzlmZDU2LTM1NTUtNDkwOS1iMTJmLTk4YmNjMWZmN2NmMCIsImMiOjR9"
          },
          {
            id: 11227,
            name: "Costaoil",
            src: "https://app.powerbi.com/view?r=eyJrIjoiZDJlZWUwNjItMTI0ZC00NmFmLTg2NjItMDQ4ZDBiMDMyMDk5IiwidCI6IjY1NzlmZDU2LTM1NTUtNDkwOS1iMTJmLTk4YmNjMWZmN2NmMCIsImMiOjR9"
          },
          {
            id: 11229,
            name: "Oilred",
            src: "https://app.powerbi.com/view?r=eyJrIjoiMGMwYTRlN2EtMDNiOS00MGQxLWI1MTYtYWYzNDYzYzdjNjY2IiwidCI6IjY1NzlmZDU2LTM1NTUtNDkwOS1iMTJmLTk4YmNjMWZmN2NmMCIsImMiOjR9"
          },
          {
            id: 11232,
            name: "Swisslub",
            src: "https://app.powerbi.com/view?r=eyJrIjoiNjdlNzMwZjItNjRlMy00YTM2LTkyNzMtZmUzYmRhMTIwMDYxIiwidCI6IjY1NzlmZDU2LTM1NTUtNDkwOS1iMTJmLTk4YmNjMWZmN2NmMCIsImMiOjR9"
          },
          {
            id: 11233,
            name: "Dlo",
            src: "https://app.powerbi.com/view?r=eyJrIjoiMDNjZTcwOTYtNjIyNi00YTM0LWEzNWUtY2MxMWIzMjg5NGZhIiwidCI6IjY1NzlmZDU2LTM1NTUtNDkwOS1iMTJmLTk4YmNjMWZmN2NmMCIsImMiOjR9"
          }
        ]
      };
    },
    methods:{
      getDistributorId(){
        axios
        .get("api/showUser")
        .then((res) => {
          if(res.status == 200){
            let distId = res.data.User.distributor_id;
            let result = this.arrayIframesByDist.find((element) => element.id === distId);
            this.iFrame = result.src;
          }
        })
        .catch((err) => {
          console.error("Ocurrió un error interno: ", err);
        });
      }
    },
    mounted(){
      this.getDistributorId();
    }
  };
</script>
  
<style scoped>
  .iframe_dashboard{
    width: 95%;
    height: 600px;
  }
  
  /* MOBILE */
  @media (max-width: 767px) {
    .iframe_dashboard{
      width: 95% !important;
      height: 500px;
    }
  }
</style>